module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "font-tip"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.tip,
      "placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shuoming"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e9f0f64","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/FontTip/FontTip.vue
// module id = 840
// module chunks = 11